import React, { useRef } from 'react';

const DEMO_REVIEWS = [
  { id: 1, customer_name: 'Анна', rating: 5, text: 'Куртка отличного качества, размер подошёл идеально. Доставили быстро.', created_at: '2025-07-15' },
  { id: 2, customer_name: 'Максим', rating: 4, text: 'Хорошие кроссовки, но ожидал более мягкую подошву.', created_at: '2025-07-10' },
  { id: 3, customer_name: 'Ольга', rating: 5, text: 'Платье великолепное! На выпускной самое то.', created_at: '2025-06-28' },
  { id: 4, customer_name: 'Дмитрий', rating: 3, text: 'Джинсы неплохие, но цвет немного отличается от фото.', created_at: '2025-06-15' },
  { id: 5, customer_name: 'Светлана', rating: 5, text: 'Рубашка отличная, муж доволен. Брала в подарок.', created_at: '2025-05-20' },
];

function ReviewSection({ productId }) {
  const reviews = DEMO_REVIEWS;
  const scrollRef = useRef(null);

  const avgRating = reviews.length > 0
    ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1)
    : 0;

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 260;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="reviews-block">
      <div className="reviews-summary">
        <div className="rating-big-block">
          <span className="rating-number-large">{avgRating}</span>
          <span className="rating-count">{reviews.length} оценок</span>
        </div>
      </div>

      <div className="reviews-carousel">
        <button className="scroll-arrow" onClick={() => scroll('left')}>‹</button>
        <div className="reviews-scroll-container" ref={scrollRef}>
          {reviews.map(r => (
            <div key={r.id} className="review-card">
              <div className="review-rating">{'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}</div>
              <p>{r.text}</p>
              <small>{r.customer_name}, {new Date(r.created_at).toLocaleDateString()}</small>
            </div>
          ))}
        </div>
        <button className="scroll-arrow" onClick={() => scroll('right')}>›</button>
      </div>
    </div>
  );
}

export default ReviewSection;